import React from 'react';

import AccountFormContainer from './AccountFormContainer';

const CreateAccountPage = () => (
  <div className="container form-only">
    <div className="row">
      <div className="col-md-12">
        <div className="card card-block">
          <h2 className="card-title">Create New Account</h2>
          <p className="card-text">
            Please fill in the fields below to create a new user account.&nbsp; All fields are
            required.&nbsp;
            <em>Note: right now status and account type are hard-locked.</em>
          </p>
          <AccountFormContainer isEdit={false} />
        </div>
      </div>
    </div>
  </div>
);

export default CreateAccountPage;
